import {
    SET_SIDEBAR_BLOCK_BOUNDS,
    SET_SIDEBAR_BLOCK_ID,
    SET_SIDEBAR_OPEN_BLOCK,
} from '../../mutation-types';

export function setOpenBlockId({ commit }, { openBlockId }) {
    commit(SET_SIDEBAR_OPEN_BLOCK, { openBlockId });
}

export function setBlockId({ commit }, { blockId }) {
    commit(SET_SIDEBAR_BLOCK_ID, { blockId });
}

export function setBlockBounds({ commit }, { blockId, bounds }) {
    commit(SET_SIDEBAR_BLOCK_BOUNDS, { blockId, bounds });
}
